// Single source of truth for the app version: the entrypoint's package.json.
// Bump the version there (and update CHANGELOG.md) and it flows through to the UI.
import pkg from '../package.json' with { type: 'json' };

export const APP_VERSION = pkg.version;
